var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('li',{staticClass:"navigation-header"},[_c('span',[_vm._v(_vm._s(_vm.label))])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }